import React, { useEffect } from "react";
import "./Loading.css";
import useEventHandler from "hooks/useEventHandler";

export interface LoadingProps {
	isGridLoader?: boolean;
	isLoading?: boolean;
	isWorkflowStepLoader?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({
	isGridLoader = false,
	isLoading = true,
	isWorkflowStepLoader = false,
}) => {
	const useEvents = useEventHandler();

	useEffect(() => {
		if (!isGridLoader) useEvents.handleElSelection(isLoading);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoading, isGridLoader]);

	return isLoading ? (
		<div
			className={
				isWorkflowStepLoader
					? "workflowStep-loader"
					: isGridLoader
					? "grid-loader"
					: "page-loader"
			}
		>
			<div className="lds-ellipsis">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	) : (
		<></>
	);
};
